<template>
  <section
    v-editable="blok"
    :class="[classObjects, hasSpacing]"
    class="practice-leads"
  >
    <div class="container">
      <div class="row align-items-center">
        <div class="practice-leads__intro col">
          <h2 class="practice-leads__title">{{ blok.title }}</h2>
          <p class="practice-leads__list-intro">{{ blok.intro }}</p>
          <a
            :href="
              blok.email_url.includes('mailto:')
                ? blok.email_url
                : `mailto:${blok.email_url}`
            "
            target="_blank"
            class="practice-leads__link"
            ><span>{{ blok.email_display }}</span></a
          >
        </div>
        <div class="col-12 col-lg-8">
          <div class="practice-leads__list row">
            <component
              :is="lead.component.toLowerCase() | dashify"
              v-for="lead in blok.practice_leads"
              :key="lead._uid"
              :blok="lead"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    classObjects() {
      return {
        'is-full-height': this.blok.isFullHeight,
      }
    },
    hasSpacing() {
      return `space--${this.blok.space}`
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.practice-leads {
  width: 100%;
  background: $black;
  color: $white;
  border-top: $gray-800 1px solid;
  border-bottom: $gray-800 1px solid;

  .media-asset img {
    width: 100%;
    min-width: 100px;
    max-width: 207px;
  }

  &__intro {
    padding-bottom: spacer(2);
  }

  &__title {
    @include font-size(36, rem-v(46));
    @include font-family($font-family-headings-bold, $headings-font-weight);

    margin: 0;
    padding: 0;
  }

  &__list {
    display: flex;
    flex-direction: row;
    list-style: none;
    padding: 0;
    margin: 0;

    &-title {
      @include font-size(16, rem-v(24));
      @include font-family($font-family-headings-bold, $headings-font-weight);

      padding: 0;
      margin: spacer(0.3) 0;
    }

    &-intro {
      margin-bottom: spacer(2);
    }

    &-person {
      padding: 0;
      margin: spacer(0.3) 0;
    }

    &-item {
      padding: 0;
      margin: 0;
    }
  }

  &__link {
    color: $white;
    cursor: pointer;
    overflow: hidden;

    &:hover {
      color: $yellow;
      text-decoration: underline;
    }
  }
}

@include media-breakpoint-up(lg) {
  .practice-leads {
    &__intro {
      border-right: $gray-800 1px solid;
      padding-bottom: 0;
      max-width: 400px;
      margin-right: 10px;
    }

    &__list {
      &-title {
        margin-top: spacer(2);
      }
    }
  }
}
</style>
